<template>
  <div
    :class="classes"
    @click="$emit('click')"
  >
    <component
      v-if="icon"
      :is="icon"
      size="xs"
      :color="iconColor"
      :active="active"
      class="icon"
    />
    <slot />
  </div>
</template>

<script>
import DataEdit from '@/components/icons/DataEdit'
import Edit from '@/components/icons/Edit'
import Delete from '@/components/icons/Delete'
import AddCircle from '@/components/icons/AddCircle'
import Close from '@/components/icons/Close'
import Code from '@/components/icons/Code'
import Open from '@/components/icons/Open'
import PageAdd from '@/components/icons/PageAdd'
import Save from '@/components/icons/Save'
import User from '@/components/icons/User'
import Settings from '@/components/icons/Settings'

export default {
  components: {
    DataEdit,
    Edit,
    Delete,
    AddCircle,
    Close,
    Code,
    Open,
    PageAdd,
    Save,
    User,
    Settings
  },
  props: {
    color: {
      type: String,
      default: 'white'
    },
    size: {
      type: String,
      default: 'm'
    },
    icon: {
      type: String,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        button: true,
        small: this.size === 's',
        middle: this.size === 'm',
        large: this.size === 'l',
        xlarge: this.size === 'xl',
        block: this.block,
        [this.color]: true
      }
    },
    iconColor () {
      return ['main', 'main-darker', 'black', 'danger'].includes(this.color) ? 'white' : 'black'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

  .button {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: $color-main;
    transition: all 250ms ease-in-out;
    font-size: 15px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.25pt;

    &:hover {
      background-color: darken($color-main, 10);
    }

    &.block {
      display: flex
    }

    .icon {
      margin-right: 15px;

      svg {
        fill: #fff !important;

        path {
          fill: #fff !important;
        }
      }
    }

    &.main {
      background-color: $color-main;

      &:hover {
        background-color: darken($color-main, 10);
      }
    }

    &.danger {
      background-color: $color-danger;

      &:hover {
        background-color: darken($color-danger, 10);
      }
    }
  }
</style>
